import React from "react";
import * as animationData from "./Dot_Lottie.json";
import "./Dot_Lottie.css";
import Lottie from "react-lottie";

export const Dot_Lottie = () => {
  const defaultOptions = {
    loop: true,
    animationData: animationData,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };
  return (
    <section className="main">
      <div className="dot_div">
        <Lottie className="me-auto" options={defaultOptions} />
      </div>
    </section>
  );
};
